import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { moduleName, ResourcesState } from './types';

export * from './types';

export function resourcesGetter(getter: string) {
  return `${moduleName}/${getter}`;
}

export const initialState: ResourcesState = {
  resources: {
    items: [],
    meta: {
      currentPage: 0,
      totalPages: 0,
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 0,
    },
  },
};

export const resourcesModule: Module<ResourcesState, RootState> = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};

export default resourcesModule;
